import { Close } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  useTheme,
} from "@mui/material";
import { GetChannels } from "contexts/ChannelsContext";
import { GetData } from "contexts/DataContext";
import { isIdentical, saveMap } from "data/functions";
import SbpLogoWithText from "data/images/sbp2.svg";
import SbpLogoWhite from "data/images/sbp_white.svg";
import React, { useEffect } from "react";

export function ButtonField(props) {
  const { dataObj, setDataObj } = GetData();
  const { changeStatus, channels, statuses } = GetChannels();
  const theme = useTheme();
  const [checked, setChecked] = React.useState(
    dataObj?.disablePayButton || false
  );

  const handleChange = (event) => {
    setDataObj(event.target.checked, "disablePayButton");
    // setChecked(event.target.checked);
  };
  useEffect(() => {
    if (!isIdentical(checked, dataObj?.disablePayButton || false)) {
      setChecked(dataObj?.disablePayButton);
    }
  }, [dataObj?.disablePayButton]);

  if (dataObj?.payType !== "self-service") return;
  return (
    <React.Fragment>
      <Typography
        sx={{
          color: theme?.palette?.text?.secondary,
          fontSize: "0.75rem",
          paddingTop: "12px",
        }}
      >
        Кнопка оплаты
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "6px",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={handleChange}
              slotProps={{
                input: { "aria-label": "controlled" },
              }}
            />
          }
          label="Отключить отображение кнопки оплаты"
        />
      </Box>
    </React.Fragment>
  );
}
